module.exports = __webpack_public_path__ + "img/cocktail.caced377.svg";